import { create } from "./create"

export const onboarding = {
  create,
}
